"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./dist/ngx-my-date-picker.module"));
__export(require("./dist/ngx-my-date-picker.input"));



//////////////////
// WEBPACK FOOTER
// ./~/ngx-mydatepicker/index.js
// module id = 605
// module chunks = 4